<template>
  <section class="flex-column">
    <a class="block block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">
          Exported Search Filters
        </h3>
      </div>
      <div class="block-content-full border-top">
        <table class="table table-striped table-condensed">
          <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Type</th>
            <th>Status</th>
            <th>File Name</th>
            <th>Created At</th>
            <th>Completed At</th>
            <th>..</th>
          </tr>
          </thead>
          <tbody class="text-sm-left">
          <tr v-for="(report, idx) of reports" :key="idx">
            <td>{{ ++idx }}</td>
            <td>{{ report.name }}</td>
            <td>{{ report.type }}</td>
            <td>{{ report.status }}</td>
            <td><small>{{ report.file_location }}</small></td>
            <td><small>{{ report.created_at }}</small></td>
            <td><small>{{ report.completed_at }}</small></td>
            <td>
              <span @click="downloadReport(report)" v-if="report.status === 'COMPLETE'">
                <button type="button" class="btn-block-option">
                  <i class="fa fa-download"/>
                </button>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </a>
  </section>

</template>

<script>
import {APP_CONFIG} from "../../config";

export default {
  name: "ExportedReports",
  data() {
    return {
      reports: [],
    }
  },
  mounted() {
    this.getProjectReports()
  },
  methods: {
    getProjectReports() {
      let project = this.$route.params.project;
      axios.get(`${APP_CONFIG.URL}web/projects/${project}/reports/exports`).then(res => {
        this.reports = res.data.data
      })
    },
    /**
     *
     * @param report
     */
    downloadReport(report) {
      let project = this.$route.params.project,
          token = this.$store.getters.getAccessToken;
      window.open(`${APP_CONFIG.URL}web/projects/${project}/reports/exports/${report.id}/download?t=${token}`, '_blank');
    }
  }
}
</script>

<style scoped>

</style>
